import React from 'react';
import { Upload, FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const UploadDocument = () => {
  return (
    <div className="upload-document" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/collaboration/documents" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Document Library
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Upload Document</h1>
          <p className="text-gray-600 mt-2">
            Upload and organize documents with metadata and tagging.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-blue-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <Upload size={48} className="text-blue-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Document Upload</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Upload documents with automatic metadata extraction, version control, and intelligent tagging. 
              This feature will be available in v1.1.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Advanced document management with OCR, AI-powered categorization, 
                automatic metadata extraction, and intelligent search capabilities.
              </p>
            </div>

            <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors flex items-center mx-auto">
              <FileText size={20} className="mr-2" />
              Upload Document
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadDocument;
